import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M21.5 2.5h-19A2.5 2.5 0 0 0 0 5v14a2.5 2.5 0 0 0 2.5 2.5h19A2.5 2.5 0 0 0 24 19V5a2.5 2.5 0 0 0-2.5-2.5M11.25 6.92a.75.75 0 0 1 1.5 0v5.5a.75.75 0 1 1-1.5 0Zm.75 11a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5m0-1.5h.75z"
    }, null, -1)
  ]));
}
const interfaceAlertErrorExclamationBlockSquare = { render };
export {
  interfaceAlertErrorExclamationBlockSquare as default,
  render
};
//# sourceMappingURL=interface-alert-error-exclamation-block-square.svg.js.map
